//REACT
import { useState } from 'react';
//CSS
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
//COMPONENTS
import Menu from './components/jsx/Menu';
import Animation from './components/jsx/Animation';
//IMAGES
import Bottom from "./images/bottom.jpg"
import Gaurill from "./images/gaurill.png"
import NewTemplate from "./images/newTemplate.png"

import Gmail from "./images/contact/gmail.png";
import Linkedin from "./images/contact/linkedin.png";
import Telegram from "./images/contact/telegram.png";

//ARRAYS
import { Answers } from './utils/Answers';

function AppEnglish() {
  
  const res = Answers
  const [answer,setAnswer]= useState('Make me a Question');
  
  const r1 =(answer) =>{ setAnswer(answer = res[0].r1_en)};
  const r2 =(answer) =>{ setAnswer(answer = res[1].r2_en)};
  const r3 =(answer) =>{ setAnswer(answer = res[2].r3_en)};
  const r4 =(answer) =>{ setAnswer(answer = res[3].r4_en)};
  const r5 =(answer) =>{ setAnswer(answer = res[4].r5_en)};
  const r6 =(answer) =>{ setAnswer(answer = res[5].r6_en)};

  return (
    <div className="global_container" id='home'>
      <header>
        
      <Menu
        title="o o o"
        link1="#home"
        link2="#projects"
        link3="#contact"
        option1="Home"
        option2="Projects"
        option3="Contact"
        ></Menu>
        
        <Menu
        title="Language"
        link1="/english"
        link2="/"
        link3="/portuguese"
        option1="English"
        option2="Spanish"
        option3="Portuguese"
        ></Menu>

      </header>
      <div className="container">

        <div className="container_1">

        <div className='container_presentation'>
        <div className="name">Mauro <br /> Calodolce</div>
        <div className="profession">Full Stack Developer</div>
        </div>

        <Animation
        first="#id"
        second=".env"
        third="(e)=>"
        fourth="<img>"
        fifth="<div>"
        ></Animation>
        
        <a href='#aboutMe' className='info' id='aboutMe' ><img className="info_img" src={Bottom} /></a>
    
        </div>
        <div className="container_2">
          <div className="titles">About Me</div>
          <div className="container2_presentation">
            <div className='container2_presentation_syntax'>
            At my 20 years, I am a Computer Technician, on the way to becoming a Full Stack Developer.
            Personally, I prefer to work on the Front-End side, however, I can perform
            well on the Back-end side. During my beginnings in web development
            make several pages exclusively with HTML and CSS, until mid-2021
            I entered the world of programming, more precisely JavaScript and several of its respective
            Frameworks. 
            </div>
        <div className='container2_presentation_questions'>

          <div className='container2_presentation_questions_questions'>
            <button id='r1' onClick={r1}>Why did you choose to be Web Development?</button>
            <button id='r2' onClick={r2}>What is your education?</button>
            <button id='r3' onClick={r3}>Languages and Frameworks?</button>
            <button id='r4' onClick={r4}>What is your experience?</button>
            <button id='r5' onClick={r5}>What languages do you speak?</button>
            <button id='r6' onClick={r6}>What do you prioritize when creating a project?</button>
          </div>
          <div className='container2_presentation_questions_answers'>{answer}</div> 
        </div>
          </div>
        </div>
        <a href='#projects' className='info' id='projects' ><img className="info_img" src={Bottom} /></a>
        <div className="titles">Projects</div>

        <div className="container_3">
        <a href='http://gaurillcomics.vercel.app' target="_blank" className="container_3_project">
          <img src={Gaurill} className="container_3_img" />
          <div className="container_3_project_info">
            <div className="container_3_project_info_title">GaurillComics</div>
            <span className="container_3_projects_info_text">
            Developed in a Onepage style, the objective of the website is to promote 
            aesthetics the work of an artistic illustrator, where users will not only be able 
            visualize the content, but they will have the possibility of contacting him.
            </span>
          </div>
        </a>

        <a href='http://newtemplate.vercel.app' target="_blank" className="container_3_project">
          <img src={NewTemplate} className="container_3_img" />
          <div className="container_3_project_info">
            <div className="container_3_project_info_title">New Template</div>
            <span className="container_3_projects_info_text">
            A simple and practical website, made for those users who are not very fond of the front-end.
            NewTemplate offers its visitors totally free HTML and CSS web templates 
            to be able to elaborate a project without the need to lay out or get out of trouble.
            </span>
          </div>
        </a>
        </div>
        <a href='#contact' className='info' id='contact' ><img className="info_img" src={Bottom} /></a>
        
        <div className="titles">Contact</div> 
        <div className="container_4">
        <div className='container_4_contact'>
          
          <a href="mailto:maucalodolce20@gmail.com?Subject=Comunicacion" target="_BLANCK" className='container_4_contact_link'><img src= {Gmail} alt="Gmail" className='container_4_contact_img' /> <p className='container_4_contact_text'>Email</p></a>
          <a href="https://ar.linkedin.com/in/mauro-calodolce-208041223" target="_BLANCK" className='container_4_contact_link'><img src={Linkedin} alt="Linkedin" className='container_4_contact_img' /><p className='container_4_contact_text'>Linkedin</p></a>
          <a href="https://t.me/Maurocalo" target="_BLANCK" className='container_4_contact_link'><img src={Telegram} alt="Telegram" className='container_4_contact_img' /><p className='container_4_contact_text'>Telegram</p></a>
        </div>

        <div className="container_4_info">
         <div className='container_4_info_link'> <img src={Gmail} className="container_4_info_img" /> maucalodolce20@gmail.com </div>
         <div className='container_4_info_link'> <img src={Telegram} className="container_4_info_img" /> @MauroCalo </div>
         <div className='container_4_info_link'> <img src={Linkedin} className="container_4_info_img" /> Mauro Calodolce </div>
        </div>
          
        </div>
        
      </div>
      <footer>

      <div className="footer_info">
      This website was developed with React Js.
          as well as the pages that are exhibited in the section of <b>Projects</b>. <br />
          ©Copyright 2022 | Mauro Calodolce
        </div>
        <div className="footer_options">
          <a href="#home" className='footer_options_option'>Home</a>
          <a href="#aboutMe" className='footer_options_option'>About Me</a>
          <a href="#projects" className='footer_options_option'>Projects</a>
          <a href="#contact" className='footer_options_option'>Contact</a>
        </div>
      <div className="footer_info">
          To change the website translation you can select
          the <b>Language</b> window at the top right.
          All translations of the website where made by me .
        </div>

      </footer>      
    </div>

  );
}

export default AppEnglish;
